"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var regeneratePlaylist_1 = __importDefault(require("../actions/generation/regeneratePlaylist"));
var playlist_1 = require("../selectors/playlist");
function regeneratePlaylistInSleepMode(dispatch, getState) {
    var state = getState();
    var shouldRegenerate = selector(state);
    if (shouldRegenerate) {
        dispatch((0, regeneratePlaylist_1.default)());
    }
}
exports.default = regeneratePlaylistInSleepMode;
function selector(state) {
    var inSleepMode = state.global.shouldSleep;
    if (!inSleepMode) {
        return false;
    }
    var currentTrack = (0, playlist_1.selectCurrentPlaylistItem)(state);
    if (!currentTrack) {
        return false;
    }
    return currentTrack.playtime < Date.now() - 10 * 60000;
}
//# sourceMappingURL=regeneratePlaylistInSleepMode.js.map